<template>
  <div class="container">
    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo de desplazamiento 25.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start px-5 pt-5">
        <h1 class="text-blue m-0 p-0 pt-3 pt-lg-5 pb-5 pb-lg-0 pe-5">{{ $t('acciones.title') }}</h1>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5" data-aos="fade-left" data-aos-duration="1000" data-aos-id="start-counter">
      <div class="row g-0 p-0 m-0">
        <div class="col-12 col-lg-9 m-auto mb-3 mt-5 mt-lg-0">
          <h2 class="p-0 m-0 mb-3">{{ $t('acciones.respeto') }}</h2>
          <h6 class="text-black"><strong>{{ $t('acciones.compormiso') }}</strong></h6>
        </div>
        <div class="col-12 col-lg-8 m-auto">
          <div class="container border border-light p-3 m-0">
            <div class="row align-items-top">
              <div class="col-12 col-lg-4 pt-2">
                <p class="m-0 p-0"><strong>{{ $t('acciones.consumo_agua') }}</strong></p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_aguaq'
                    :startAmount='0'
                    :endAmount='18504'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">m<sup>3</sup></span></h2>
                <p class="textSmall text-black">{{ $t('acciones.consumo_aguaq') }}</p>
              </div>
              <div class="col-12 col-lg-4 pt-2">
                <p class="m-0 p-0"><strong>{{ $t('acciones.consumo_electricidad') }}</strong></p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_kWh'
                    :startAmount='0'
                    :endAmount='5395978'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">kWh</span></h2>
              </div>
              <div class="col-12 col-lg-4 pt-2">
                <p class="m-0 p-0"><strong>{{ $t('acciones.consumo_gas') }}</strong></p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_kWh2'
                    :startAmount='0'
                    :endAmount='279456'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">kWh</span></h2>
              </div>
            </div>
            <div class="row align-items-top">
              <div class="col-12 col-lg-4 pt-2">
              </div>
              <div class="col-12 col-lg-4 py-3 border-bottom border-light">
                <p class="textSmall text-black p-0 m-0">{{ $t('acciones.emisiones_electricidad') }}</p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_co2'
                    :startAmount='0'
                    :endAmount='1392'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">tCO<sub>2</sub></span></h2>
              </div>
              <div class="col-12 col-lg-4 py-3 border-bottom border-light">
                <p class="textSmall text-black p-0 m-0">{{ $t('acciones.emisiones_gas') }}</p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_co22'
                    :startAmount='0'
                    :endAmount='71'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                />  <span class="textSmall">tCO<sub>2</sub></span></h2>
              </div>
            </div>
            <div class="row align-items-top">
              <div class="col-12 col-lg-4 pt-2">
              </div>
              <div class="col-12 col-lg-8 pt-4">
                <p class="m-0 p-0"><strong>{{ $t('acciones.emisiones_totales') }}</strong></p>
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_co23'
                    :startAmount='0'
                    :endAmount='1463'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">tCO<sub>2</sub></span></h2>
              </div>
            </div>
          </div>
          <hr class="filigrana">
        </div>
        <div class="col-12 col-lg-9 m-auto mb-3">
          <h2 class="p-0 m-0 mb-3">{{ $t('acciones.impacto_positivo') }}</h2>
          <h6 class="text-black"><strong>{{ $t('acciones.compormispo_social') }}</strong></h6>
        </div>
        <div class="col-12 col-lg-8 m-auto">
          <div class="container border border-light py-3 m-0" data-aos="fade-left" data-aos-duration="1000" data-aos-id="start-counter-comision">
            <div class="row align-items-top">
              <div class="col-12 pt-2">
                <p class="m-0 p-0"><strong>{{ $t('acciones.comision') }}</strong></p>
              </div>
            </div>
            <div class="row align-items-top">
              <div class="col-12 col-lg-6 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_solicitudes'
                    :startAmount='0'
                    :endAmount='118'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall text-black">{{ $t('acciones.solicitudes') }}</p>
              </div>
              <div class="col-12 col-lg-6 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_aydas'
                    :startAmount='0'
                    :endAmount='103988'
                    :duration='2'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /> <span class="textSmall">€</span></h2>
                <p class="m-0 p-0"><strong>{{ $t('acciones.en_ayudas') }}</strong></p>
                <div class="col-12 col-lg-6 border-end border-light py-4"></div>
                <h5 class="p-0 m-0">+<AnimatedNumber
                    ref='counter_percent_3'
                    :startAmount='0'
                    :endAmount='5.9'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='1'
                    :autoinit='true'
                    @finished='counterFinished'
                />%</h5>
                <p class="textSmall text-black">{{ $t('acciones.respecto2') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana">

        </div>
      </div>

    </section>

    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/sostenibilidad/nuestra-contribucion-a-los-ods"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.nuestra-contribucion-a-los-ods") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
      </div>
    </div>

  </div>

</template>

<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ','
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter', this.startCounter);
    document.addEventListener('aos:in:start-counter-comision', this.startCounterComision);

    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_aguaq != null) {
        this.$refs.counter_aguaq.start();
      }
      if (this.$refs.counter_kWh != null) {
        this.$refs.counter_kWh.start();
      }
      if (this.$refs.counter_percent != null) {
        this.$refs.counter_percent.start();
      }
      if (this.$refs.counter_kWh2 != null) {
        this.$refs.counter_kWh2.start();
      }
      if (this.$refs.counter_co2 != null) {
        this.$refs.counter_co2.start();
      }
      if (this.$refs.counter_co22 != null) {
        this.$refs.counter_co22.start();
      }
      if (this.$refs.counter_co23 != null) {
        this.$refs.counter_co23.start();
      }
      if (this.$refs.counter_percent_2 != null) {
        this.$refs.counter_percent_2.start();
      }
    },
    startCounterComision() {
      if (this.$refs.counter_solicitudes != null) {
        this.$refs.counter_solicitudes.start();
      }
      if (this.$refs.counter_aydas != null) {
        this.$refs.counter_aydas.start();
      }
      if (this.$refs.counter_percent_3 != null) {
        this.$refs.counter_percent_3.start();
      }


    }
  }
}
</script>
